<template>
  <div class="section pt-5">
    <div v-if="patient">
      <div class="title is-4">{{ $t("patient") }} {{ patient.name }}</div>
      <div class="subtitle is-6 mb-0" v-if="patient.phone">
        <span class="icon">
          <i class="fa fa-phone"></i>
        </span>
        <span>{{ patient.phone }}</span>
      </div>
      <div class="subtitle is-6" v-if="patient.email">
        <span class="icon">
          <i class="fa fa-envelope"></i>
        </span>
        <span>{{ patient.email }}</span>
      </div>
      <appointments ref="appointments" />
      <!-- <pre>{{ patient }}</pre> -->
    </div>
    <div v-else>
      <div class="notification is-danger">
        <button class="delete" @click="refresh"></button>
        {{ $t("patient_not_found") }}
      </div>
    </div>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import Appointments from "./profile_components/appointments/Index.vue";

export default {
  name: "PatientProfile",
  components: { Appointments },
  data() {
    return {
      patient: {},
    };
  },
  methods: {
    refresh() {
      let v = this;
      get("/animal/details", { uuid: v.$route.params.patient_uuid })
        .then((patient) => {
          v.patient = patient;
          v.$refs.appointments.refresh();
        })
        .catch((error) => {
          v.patient = undefined;
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
